import { CsvMappingApiModel } from '~/lib/api/smartsend/types';

export function MappingIsDefault(mapping: CsvMappingApiModel) {
  return mapping.Tags.includes('Default');
}
